var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 48,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_701_1440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.853 29.1849C17.1603 28.8786 17.5515 28.7254 18.0265 28.7254C18.5015 28.7254 18.8927 28.8786 19.2 29.1849L22.3434 32.3182L22.3434 21.9992C22.3434 21.5257 22.5043 21.1286 22.8262 20.8077C23.1481 20.4869 23.546 20.327 24.0199 20.3281C24.4949 20.3281 24.8933 20.4885 25.2152 20.8094C25.5371 21.1302 25.6975 21.5268 25.6963 21.9992L25.6963 32.3182L28.8397 29.1849C29.1471 28.8786 29.5455 28.7254 30.035 28.7254C30.5246 28.7254 30.9224 28.8786 31.2287 29.1849C31.536 29.4913 31.6897 29.8812 31.6897 30.3547C31.6897 30.8282 31.536 31.2181 31.2287 31.5245L25.1934 37.5404C25.0257 37.7075 24.8441 37.8262 24.6485 37.8964C24.453 37.9666 24.2434 38.0011 24.0199 38C23.7963 38 23.5868 37.9649 23.3912 37.8947C23.1956 37.8245 23.014 37.7064 22.8463 37.5404L16.8111 31.5245C16.5037 31.2181 16.3567 30.8282 16.3702 30.3547C16.3836 29.8812 16.5445 29.4913 16.853 29.1849ZM6.75228 12.4739L12.7876 6.45798C12.9552 6.29087 13.1368 6.17222 13.3324 6.10204C13.528 6.03185 13.7375 5.99787 13.9611 6.0001C14.1846 6.0001 14.3942 6.0352 14.5898 6.10538C14.7853 6.17557 14.967 6.2931 15.1346 6.45798L21.1699 12.4739C21.4772 12.7803 21.6309 13.1702 21.6309 13.6437C21.6309 14.1172 21.4772 14.5071 21.1699 14.8135C20.8625 15.1198 20.4641 15.273 19.9746 15.273C19.485 15.273 19.0871 15.1198 18.7809 14.8135L15.6375 11.6802L15.6375 21.9992C15.6375 22.4727 15.4766 22.8698 15.1547 23.1907C14.8328 23.5115 14.435 23.6714 13.9611 23.6703C13.4861 23.6703 13.0876 23.5099 12.7658 23.189C12.4439 22.8682 12.2835 22.4716 12.2846 21.9992L12.2846 11.6802L9.14124 14.8135C8.83389 15.1198 8.44271 15.273 7.96771 15.273C7.49271 15.273 7.10154 15.1198 6.79419 14.8135C6.48684 14.5071 6.3259 14.1172 6.31137 13.6437C6.29684 13.1702 6.44381 12.7803 6.75228 12.4739Z",
    fill: "#D23B38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_701_1440",
    x: -3,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_701_1440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_701_1440",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSwap);
export default __webpack_public_path__ + "static/media/mobile-swap.60933927c48a6c8a8e0b7028833a70b3.svg";
export { ForwardRef as ReactComponent };